import script from "./CatalogProductsBulkSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogProductsBulkSearch.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogProductsBulkSearch.vue?vue&type=style&index=0&id=3d3e97c0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d3e97c0"]])

export default __exports__